import React, { useEffect, useState, useCallback, useMemo, useRef } from "react";
import CustomTable from "src/components/App/AppGrid/CustomTable/CustomTable";
import { Avatar, Chip, Box, alpha, Typography, DialogContent, DialogTitle, DialogActions, styled } from "@mui/material";
import Welcome from "../components/patient/Welcome";
import theme from "src/config/theme";
import { ReactComponent as Profile } from '../../../assets/images/profile-circle.svg';
import { ReactComponent as ArrowRight } from '../../../assets/images/arrow-right 2.svg';
import { ReactComponent as SliderVertical } from '../../../assets/images/slider-vertical.svg';
import { ReactComponent as Close } from '../../../assets/images/close-circle.svg';
import { ReactComponent as Complete } from '../../../assets/images/tick-circle.svg';
import { ReactComponent as Rotate } from '../../../assets/images/rotate-right.svg'
import { useNavigate } from 'react-router-dom';
import NoDataFound from "../components/NoDataFound/NoDataFound";
import { useDispatch, useSelector } from 'react-redux';
import { getAppointmentRequest, updateRecordStatusRequest } from '../../../modules/app/store/appActions';
import storage from "src/utils/storageUtils";
import RightSidebar from "../../../components/App/RIghtSidebar/RightSidebar";
import DialogBox from "src/components/shared/Dialog/DialogBox";
import dayjs from "dayjs";
import { postNotification } from "src/modules/app/api/appApi";
import { getUserFromToken } from "src/DecodeToken";
import AppointmentCard from "src/modules/app/components/CustomCard/AppointmentCard";
import useResponsive from "src/components/hooks/useResponsive";
import { ReactComponent as Add } from '../../../assets/images/add-square.svg';
import DeleteDialog from "../components/DeleteDialog";
import AddAppointment from "../components/LefSidebarForms/AddAppointment/AddAppointment";
import { getPatient } from "../api/appApi";
import { isSanginiRestrictedUser } from "src/utils/sanginiUtils";

export const AvatarIcon = styled(Avatar)({
  width: '64px',
  height: '64px',
  padding: '10px',
  borderRadius: '40px',
  background: 'linear-gradient(0deg, rgba(150, 57, 57, 0.18), rgba(150, 57, 57, 0.18)), #FFFFFF',
  marginBottom: '5px'
})

const columns = [
  { id: "appointmentIdCol", label: "Appt ID", sx: { "& .css-axw7ok": { justifyContent: 'center !important' } }, },
  { id: "patientIdCol", label: "Patient ID", sx: { "& .css-axw7ok": { justifyContent: 'center !important' } }, },
  { id: "patient", label: "Patient Details", sx: { "& .css-s1474d": { justifyContent: 'flex-Start !important' } }, },
  { id: "age", label: "Age", sx: { "& .css-axw7ok": { justifyContent: 'center !important' } }, },
  { id: "sex", label: "Sex", sx: { "& .css-axw7ok": { justifyContent: 'center !important' } }, },

  { id: "symptoms", label: "Symptoms", sx: { "& .css-axw7ok": { justifyContent: 'center !important' } }, },
  { id: "status", label: "Status", sx: { "& .css-axw7ok": { justifyContent: 'center !important' } }, },
  { id: "date", label: "Date & Time", sx: { "& .css-axw7ok": { justifyContent: 'center !important' } }, }
];

const AppointmentContainer = () => {
  const { isMobile, isDesktop, isTablet } = useResponsive();
  const drawerWidth = '280px'
  const [isCardView, setIsCardView] = useState(false);
  const [open, setOpen] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [preselectPatientId, setPreselectPatientId] = useState(null);
  const handleOpenDialog = (patientId = null) => {
    setPreselectPatientId(patientId);
    setOpenDialog(true);
  };
  const handleCloseDialog = () => {
    setOpenDialog(false);
    setPreselectPatientId(null);
  };
  const [openComplete, setOpenComplete] = useState(false);
  const [appointments, setAppointments] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth?.user);
  const isSangini = isSanginiRestrictedUser(user);
  // const [selectedDate, setSelectedDate] = useState(dayjs().startOf('day'));
  const Width = isMobile || isTablet ? '20px' : '24px';
  const Height = isMobile || isTablet ? '20px' : '24px';

  const [selectedDate, setSelectedDate] = useState();
  const [selectedStatus, setSelectedStatus] = useState("");
  const [page, setPage] = useState(0);
  const [perPage, setPerPage] = useState(10);

  const [selectedAppointmentId, setSelectedAppointmentId] = useState(null);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const handleOpen = (appointmentId, patientData) => {
    setSelectedAppointmentId(appointmentId);
    setSelectedPatient(patientData)
    setOpen(true);
  };
  const handleClose = () => {
    setSelectedAppointmentId(null);
    setSelectedPatient(null)
    setOpen(false);
  };

  const handleCompleteOpen = (appointmentId, patientData) => {
    setSelectedAppointmentId(appointmentId);
    setSelectedPatient(patientData)
    setOpenComplete(true);
  }
  const handleCompleteClose = () => {
    setSelectedAppointmentId(null);
    setSelectedPatient(null)
    setOpenComplete(false);
  }
  const fetchAppointments = useCallback(
    () => {
      const token = storage.get('TOKEN');
      const fetchData = async () => {
        setIsLoading(true);
        let allData = [];
        let pageIndex = 1;
        const limit = 100; // Fetch in larger chunks
        
        while (true) {
          const params = {
            page: pageIndex,
            limit,
          };
          
          try {
            const response = await new Promise((resolve, reject) =>
              dispatch(getAppointmentRequest({ token, params }, resolve, reject)),
            );
            
            if (response && response.data && Array.isArray(response.data)) {
              allData = [...allData, ...response.data];
              
              // Stop if we've reached the total or the current response is smaller than limit
              if (response.data.length < limit || (response.meta?.total && allData.length >= response.meta.total)) {
                break;
              }
              pageIndex++;
            } else {
              break;
            }
          } catch (err) {
            console.error('Error fetching appointments chunk:', err);
            break;
          }
        }
        
        setAppointments(allData);
        setIsLoading(false);
      };
      fetchData();
    },
    [dispatch],
  );

  useEffect(() => {
    fetchAppointments();
  }, [fetchAppointments]);

  useEffect(() => {
    const handleOpenQueue = () => setSidebarOpen(true);
    window.addEventListener('app:openQueueDrawer', handleOpenQueue);
    return () => window.removeEventListener('app:openQueueDrawer', handleOpenQueue);
  }, []);

  useEffect(() => {
    setPage(0);
  }, [searchQuery, selectedDate, selectedStatus]);


  const updateAppointmentStatus = async (appointmentId, status, onSuccess) => {
    const updatedData = { recordStatus: status };

    try {
      const response = await new Promise((resolve, reject) => {
        dispatch(updateRecordStatusRequest(appointmentId, updatedData, resolve, reject));
      });

      if (response) {
        console.log(`Status updated successfully to ${status}`);

        setAppointments((prevAppointments) =>
          prevAppointments.map((appointment) =>
            appointment.id === appointmentId
              ? { ...appointment, recordStatus: status }
              : appointment
          )


        );
        try {
          const appt = appointments.find(a => a.id === appointmentId);
          const user = getUserFromToken();
          if (appt && user) {
            const when = `${dayjs(appt.date).format('DD-MM-YYYY')} ${appt.time}`;
            const message = status === 'Cancelled'
              ? `Appointment for ${appt.patient?.fullName || 'patient'} on ${when} has been cancelled.`
              : `Appointment for ${appt.patient?.fullName || 'patient'} updated to "${status}" (${when}).`;
            await postNotification({
              message,
              url: `${window.location.origin}/appointment/Patients/${appointmentId}`,
              user
            });
            window.dispatchEvent(new CustomEvent('app:notificationCreated'));
          }
        } catch (_) {}
        if (onSuccess) onSuccess();
      }
    } catch (error) {
      console.error(`Failed to update status to ${status}:`, error);
    }
  };

  const handleAddToQueue = (appointmentId) => {
    updateAppointmentStatus(appointmentId, "In Queue", () => setSidebarOpen(true));
  };

  const handleCancelAppointment = (appointmentId, patient) => {
    updateAppointmentStatus(appointmentId, "Cancelled", handleClose);
  };
  const handleCompleteAppointment = (appointmentId) => {
    updateAppointmentStatus(appointmentId, "Complete", handleCompleteClose)
  }
  const handleAttendNowAppointment = (appointmentId) => {
    if (isSangini) {
      updateAppointmentStatus(appointmentId, "Attending Now", () => setSidebarOpen(true));
    } else {
      updateAppointmentStatus(appointmentId, "Attending Now", () => navigate(`/appointment/Patients/${appointmentId}`));
    }
  };


  const formatTime = (time) => {
    if (typeof time === 'string' && !time.includes('T')) return time;
    try {
      const dateObj = new Date(time);
      return dateObj.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
      });
    } catch (e) {
      return 'Invalid Time';
    }
  };

  // const filteredAppointments = useMemo(() => {
  //   return appointments.filter((item) => {
  //     const matchesDate = selectedDate
  //       ? dayjs(item.date).isSame(dayjs(selectedDate), 'day')
  //       : true;

  //     const matchesStatus = selectedStatus
  //       ? item.recordStatus === selectedStatus
  //       : true;

  //     return matchesDate && matchesStatus;
  //   });
  // }, [appointments, selectedDate, selectedStatus]);


  const filteredAppointments = useMemo(() => {
    return appointments.filter((item) => {
      const matchesDate = selectedDate
        ? dayjs(item.date).isSame(dayjs(selectedDate), 'day')
        : true;

      const matchesStatus = selectedStatus
        ? item.recordStatus?.trim().toLowerCase() === selectedStatus?.trim().toLowerCase()
        : true;

      const matchesSearch = searchQuery
        ? (item.patient?.fullName?.toLowerCase() || '').includes(searchQuery.toLowerCase()) ||
          (item.appointmentId?.toLowerCase() || '').includes(searchQuery.toLowerCase()) ||
          (item.patient?.patientId?.toLowerCase() || '').includes(searchQuery.toLowerCase())
        : true;

      return matchesDate && matchesStatus && matchesSearch;
    });
  }, [appointments, selectedDate, selectedStatus, searchQuery]);

  const totalCount = filteredAppointments.length;
  const paginatedAppointments = useMemo(() => {
    const start = page * perPage;
    return filteredAppointments.slice(start, start + perPage);
  }, [filteredAppointments, page, perPage]);

  // Client-side appointment reminder at appointment time
  const remindedRef = useRef(new Set());
  useEffect(() => {
    const storeKey = 'appointment_reminded_ids';
    try {
      const saved = JSON.parse(sessionStorage.getItem(storeKey) || '[]');
      remindedRef.current = new Set(saved);
    } catch (_) {}
    const interval = setInterval(async () => {
      const now = dayjs();
      for (const appt of appointments) {
        const id = appt.id;
        if (remindedRef.current.has(id)) continue;
        let apptTime = dayjs(appt.date);
        if (appt.time) {
          const t = dayjs(appt.time, ['HH:mm', 'hh:mm A', 'h:mm A']);
          apptTime = apptTime.hour(t.hour()).minute(t.minute()).second(0);
        }
        if (now.isSame(apptTime, 'minute')) {
          try {
            const user = getUserFromToken();
            if (user) {
              await postNotification({
                message: `Appointment reminder for ${appt.patient?.fullName || 'patient'} at ${apptTime.format('hh:mm A')} on ${apptTime.format('DD-MM-YYYY')}.`,
                url: `${window.location.origin}/appointment/Patients/${id}`,
                user
              });
              window.dispatchEvent(new CustomEvent('app:notificationCreated'));
              remindedRef.current.add(id);
              sessionStorage.setItem(storeKey, JSON.stringify(Array.from(remindedRef.current)));
            }
          } catch (_) {}
        }
      }
    }, 60000);
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appointments]);

  const data = paginatedAppointments.map((appointment) => {
    return {
    appointmentId: appointment.id,
    patientData: appointment?.patient,
    patient: (
      <Box sx={{ display: "flex", justifyContent: 'center', alignItems: "center", gap: "8px" }}>
        <Avatar 
          sx={{ background: theme.palette.primary.light4, color: theme.palette.primary.main }}
        >
          {appointment.patient?.fullName?.charAt(0).toUpperCase() || 'P'}
        </Avatar>
        <span>{appointment.patient?.fullName || "N/A"}</span>
      </Box>
    ),
    appointmentIdCol: (
      <Typography variant="body2" sx={{ fontWeight: 600, color: theme.palette.primary.main }}>
        {appointment.appointmentId || 'APT-N/A'}
      </Typography>
    ),
    patientIdCol: (
      <Typography variant="body2" sx={{ color: theme.palette.text.secondary, fontWeight: 500 }}>
        {appointment.patient?.patientId || 'MYC-N/A'}
      </Typography>
    ),
    age: appointment.patient?.detailedAge?.ageString 
      ? appointment.patient.detailedAge.ageString.replace(/Years|Year/g, 'Y').replace(/Months|Month/g, 'M').replace(/Days|Day/g, 'D') 
      : (appointment.patient?.age ? `${appointment.patient.age} Y` : 'N/A'),
    sex: appointment.patient?.gender
      ? `${appointment.patient.gender.charAt(0).toUpperCase() + appointment.patient.gender.slice(1)}`
      : 'N/A',

    symptoms: appointment.addnotes,
    status: (
      <Chip
        label={appointment.recordStatus}
        sx={{
          background:
            appointment.recordStatus === "Scheduled" ? "linear-gradient(0deg, rgba(150, 57, 150, 0.12), rgba(150, 57, 150, 0.12))" :
              appointment.recordStatus === "In Queue" ? "linear-gradient(0deg, rgba(103, 57, 150, 0.14), rgba(103, 57, 150, 0.14))" :
                appointment.recordStatus === "Attending Now" ? "linear-gradient(0deg, rgba(57, 150, 57, 0.18), rgba(57, 150, 57, 0.18))" :
                  appointment.recordStatus === "Complete" ? "linear-gradient(0deg, rgba(57, 150, 57, 0.18), rgba(57, 150, 57, 0.18))" :
                    appointment.recordStatus === "Cancelled" ? "linear-gradient(0deg, rgba(150, 57, 57, 0.18), rgba(150, 57, 57, 0.18))" :
                      appointment.recordStatus === "Overdue" ? "linear-gradient(0deg, rgba(150, 57, 57, 0.18), rgba(150, 57, 57, 0.18))" :
                        appointment.recordStatus === "Treatment Scheduled" ? "linear-gradient(0deg, rgba(150, 57, 150, 0.12), rgba(150, 57, 150, 0.12))" :

                          "linear-gradient(0deg, rgba(200, 200, 200, 0.18), rgba(200, 200, 200, 0.18))",
          color:
            appointment.recordStatus === "Scheduled" ? theme.palette.action.purpleDark :
              appointment.recordStatus === "In Queue" ? theme.palette.action.purpleLight :
                appointment.recordStatus === "Attending Now" ? theme.palette.action.green :
                  appointment.recordStatus === "Complete" ? theme.palette.action.green :
                    appointment.recordStatus === "Cancelled" ? theme.palette.action.red :
                      appointment.recordStatus === "Overdue" ? theme.palette.action.red :
                        appointment.recordStatus === "Treatment Scheduled" ? theme.palette.action.purpleDark :
                          theme.palette.gery.black,
          ...theme.typography.small,
          borderRadius: '100px',
          padding: '10px 18px 8px 18px',
        }}
      />
    ),
    date: `${dayjs(appointment.date).format("DD-MM-YYYY")}, ${formatTime(appointment.time)}`,
    contact: appointment?.patient?.contactNo || "N/A"
  };});



  const getActionsForRow = (row) => {
    if (!row) {
      return [];
    }

    const viewProfileAction = {
      label: "View Profile",
      icon: <Profile width={Width} height={Height} />,
      disabled: isSangini,
      onClick: () => {
        if (!isSangini) {
          navigate(`/appointment/Patients/${row.appointmentId}`);
        }
      },
    };

    const bookAgainAction = {
      label: "Book Again",
      icon: <Rotate width={Width} height={Height} />,
      onClick: () => handleOpenDialog(row.patientData?.id || null),
    };

    const baseActions = [
      viewProfileAction,
      { label: "Attend Now", icon: <ArrowRight width={Width} height={Height} />, onClick: () => handleAttendNowAppointment(row.appointmentId) },
      { label: "Add to Queue", icon: <SliderVertical width={Width} height={Height} />, onClick: () => handleAddToQueue(row.appointmentId) },
      // { label: "Edit", icon: <Edit />, onClick: () => alert(`Editing ${row.patient}`) },
      { label: "Complete", icon: <Complete />, onClick: () => handleCompleteOpen(row.appointmentId, row.patientData) },
      {
        label: "Cancel",
        icon: <Close width={Width} height={Height} />,
        onClick: () => handleOpen(row.appointmentId, row.patientData),
      },
    ];

    const statusLabel = row.status?.props?.children || row.status?.props?.label || "";

    if (statusLabel === "In Queue") {
      return baseActions.filter(action => action.label !== "Add to Queue" && action.label !== "Complete");
    }

    if (statusLabel === "Attending Now") {
      return baseActions.filter(action => !["Add to Queue", "Attend Now", "Edit"].includes(action.label));
    }
    if (["Treatment Scheduled", "Scheduled"].includes(statusLabel)) {
      return baseActions.filter(action => action.label !== "Complete");
    }
    if (["Cancelled", "Complete"].includes(statusLabel)) {
      return isSangini ? [viewProfileAction] : [viewProfileAction, bookAgainAction];
    }
    return baseActions;
  };

  return (
    <>
      <Welcome category="appointments" setIsCardView={setIsCardView} isCardView={isCardView} updateAppointments={fetchAppointments} handleSearch={setSearchQuery} selectedDate={selectedDate}
        setSelectedDate={setSelectedDate} selectedStatus={setSelectedStatus} setSelectedStatus={setSelectedStatus} />

      <Box sx={{ mb: 16 }} />

      <Box sx={{
        height: 'calc(100vh - 240px)',
        margin: 2,
        boxShadow: isMobile || isTablet || isCardView || isCardView ? 'none' : theme.shadows[1],
        borderRadius: '10px',
        border: isMobile || isTablet || isCardView || isCardView ? 'none' : `1px solid ${alpha(theme.palette.gery.black, 0.1)}`,
        backgroundColor: isMobile || isTablet || isCardView ? 'none' : theme.palette.gery.white,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: (isCardView) && Array.isArray(data) && data.length === 0 ? 'center' : 'space-between',
        alignItems: (isMobile || isTablet || isCardView) && Array.isArray(data) && data.length === 0 ? 'center' : 'none',
        position: 'relative',
        maxHeight: 'calc(100vh - 240px)'
      }}>
        {(isMobile || isTablet || isCardView) ? (
          data.length === 0 ? (
            isLoading ? null : (
              <NoDataFound
                title="No Appointment Found!"
                buttonText="Add Appointment"
                buttonIcon={Add}
                disabled={isSangini}
                onClick={isSangini ? undefined : handleOpenDialog}
              />
            )
          ) : (
            <AppointmentCard
              data={data}
              page={page}
              perPage={perPage}
              setPage={setPage}
              totalCount={totalCount}
              handleAttendNowAppointment={handleAttendNowAppointment}
              handleAddToQueue={handleAddToQueue}
              handleCompleteOpen={handleCompleteOpen}
              handleCancelAppointment={handleCancelAppointment}
              handleOpen={handleOpen}
            />
          )
        ) : (
          <CustomTable
            columns={columns}
            data={data}
            actions={(row) => getActionsForRow(row)}
            page={page}
            onPageChange={(newPage) => {
              setPage(newPage);
            }}
            onPerPageChange={(newPerPage) => {
              setPerPage(newPerPage);
              setPage(0);
            }}
            perPage={perPage}
            totalCount={totalCount}
            loading={isLoading}
            noDataComponent={
              isLoading ? <></> : (
                <NoDataFound
                  title="No Appointment Found!"
                  buttonText="Add Appointment"
                  buttonIcon={Add}
                  disabled={isSangini}
                  onClick={isSangini ? undefined : handleOpenDialog}
                />
              )
            }
          />
        )}


      </Box>

      <RightSidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <DeleteDialog
        open={open}
        onClose={handleClose}
        onConfirm={handleCancelAppointment}
        idToDelete={selectedAppointmentId}
        title="Cancel Appointment"
        message="Are you sure you want to cancel appointment of"
        subtitle={selectedPatient ? `${selectedPatient.fullName}` : "Loading..."}
        confirmText="Yes"
      />

      <DeleteDialog
        open={openComplete}
        onClose={handleCompleteClose}
        onConfirm={handleCompleteAppointment}
        idToDelete={selectedAppointmentId}
        title="Appointment Completed"
        message={`Appointment of ${selectedPatient ? `${selectedPatient.fullName} ` : 'Loading'} Completed Successfully`}
        confirmText="OK"
      />
      <DialogBox open={openDialog} onClose={handleCloseDialog} >
        <AddAppointment onClose={handleCloseDialog} updateAppointments={fetchAppointments} initialPatientId={preselectPatientId} />
      </DialogBox>


    </>
  )
};

export default AppointmentContainer;